import { useState } from "react";
import { rankings, rankingCovers } from "@/mocks/manga";

const tabs = [
  { key: "week", label: "周榜" },
  { key: "month", label: "月榜" },
  { key: "all", label: "总榜" },
] as const;

type TabKey = (typeof tabs)[number]["key"];

const rankBadge = (rank: number) => {
  if (rank === 1) return "bg-accent-500 text-foreground-950";
  if (rank === 2) return "bg-secondary-500 text-background-50";
  if (rank === 3) return "bg-primary-500 text-background-50";
  return "bg-background-200 text-foreground-700";
};

export default function Ranking() {
  const [active, setActive] = useState<TabKey>("week");
  const list = rankings[active];

  return (
    <section id="ranking" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-medium text-accent-800">
            <i className="ri-trophy-line"></i>
            热门榜单 · 每日刷新
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">今日人气榜单</h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">
            热度综合播放、追更人数与读者互动计算，霸榜作品实时追踪。
          </p>
        </div>
        <div className="inline-flex rounded-full bg-background-200/70 p-1">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={`rounded-full px-5 py-2 text-sm whitespace-nowrap transition-colors ${
                active === tab.key
                  ? "bg-primary-500 font-medium text-background-50"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
        {list.map((item, i) => (
          <article
            key={`${active}-${item.title}`}
            className="flex items-center gap-4 rounded-xl bg-background-100 p-4 ring-1 ring-background-200/70"
          >
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-heading text-lg ${
                i < 3 ? rankBadge(i + 1) : "bg-background-200 text-foreground-700"
              }`}
            >
              {i + 1}
            </span>
            <img
              src={i % 3 === 0 ? rankingCovers.week : i % 3 === 1 ? rankingCovers.month : rankingCovers.all}
              alt={`${item.title} 漫画封面`}
              className="h-20 w-14 shrink-0 rounded-md object-cover object-top"
            />
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-2">
                <h3 className="truncate font-medium text-foreground-950">{item.title}</h3>
                <span className="shrink-0 whitespace-nowrap text-sm font-semibold text-primary-600">{item.heat}</span>
              </div>
              <p className="mt-0.5 truncate text-xs text-foreground-600">
                {item.author} · {item.type}
              </p>
              <div className="mt-2 flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                  <i className="ri-file-list-3-line"></i>
                  连载至 {item.chapters} 话
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800">
                  <i className="ri-refresh-line"></i>
                  {item.weeklyUpdate}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}